import { Box } from "@mui/material";
import FormRowLink from "@/components/common/forms/formRowLink";
import FormStatusChip from "@/components/common/forms/formStatusChip";
import { FormStatus } from "@/components/common/forms/formStatusIcon";
import ConsentFormHeader from "../../../common/consentForms/consentFormHeader";
import { ConsentForm } from "./consentFormDetailsView";

type Props = {
  form: ConsentForm;
  url: string;
  withButton?: boolean;
};

const ConsentFormTile = ({ form, url, withButton }: Props) => {
  const showButton = withButton && !form.signedAt;

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 1,
        }}
      >
        <Box sx={{ mt: 0 }}>
          <FormStatusChip
            status={
              form.signedAt ? FormStatus.SUBMITTED : FormStatus.INCOMPLETE
            }
          />
        </Box>
      </Box>

      <FormRowLink url={url} showButton={showButton}>
        <ConsentFormHeader
          name={form.consentForm.name}
          signedAt={form.signedAt}
          textSx={{ typography: "subtitleDefault" }}
          isOptOut={form.isOptOut}
        />
      </FormRowLink>
    </Box>
  );
};

export default ConsentFormTile;
